import React from "react";
import { IconProps, Styles } from "@/shared/coralreef";

import { Icon } from "@/shared/coralreef";
import { percent, px } from "csx";
import { FC } from "react";
import { style } from "typestyle";
import { Horizontal } from "gls";
import { Badge } from "@/shared/components/badge/Badge";
import { Vertical, Content, Stretch, Box } from "gls";

export const SitesListItem: FC<{
  isCollapsed?: boolean;
  hideTextWhenCollapsed?: boolean;
  isHighlighted?: boolean;
  isDeactivated?: boolean;
  icon?: IconProps["icon"];
  text: string;
  collapsedText?: string;
  alertCount?: number;
  disabled?: boolean;
  onClick?: () => void;
}> = React.memo(
  ({
    isCollapsed,
    hideTextWhenCollapsed,
    icon,
    isHighlighted,
    isDeactivated,
    text,
    collapsedText,
    alertCount,
    disabled,
    onClick,
  }) => {
    return (
      <Horizontal
        height={isCollapsed ? "none" : px(20)}
        maxHeight={isCollapsed ? "none" : px(20)}
        spacing={10}
        padding={[px(15), isCollapsed ? 0 : px(10)]}
        horizontalAlign={isCollapsed ? "center" : "left"}
        verticalAlign="center"
        sizing="stretch"
        onClick={(e) => !disabled && onClick?.()}
        className={style({
          cursor: "pointer",
          color: disabled
            ? Styles.Colours.textDisabled
            : isHighlighted
              ? "white"
              : isDeactivated
                ? Styles.Colours.red
                : "inherit",
          overflow: "hidden",
          fontWeight: isHighlighted ? "bold" : "auto",
          opacity: isDeactivated ? percent(60) : 1,
        })}
        data-testid="sites-list-item"
      >
        <Vertical
          spacing={px(5)}
          sizing={isCollapsed ? "stretch" : "content"}
          horizontalAlign="center"
          maxHeight={px(40)}
          width={isCollapsed ? percent(100) : "auto"}
        >
          {icon && (
            <Content className={iconContainer}>
              <Icon icon={icon} />
              {(alertCount || 0) > 0 && isCollapsed && (
                <Box className={alertDot} />
              )}
            </Content>
          )}
          {isCollapsed && !hideTextWhenCollapsed && (
            <Stretch
              horizontalAlign="center"
              padding={[0, px(5)]}
              width={percent(100)}
              className={style({ boxSizing: "border-box" })}
            >
              <span className={collapsedTextContainer}>
                {collapsedText || text}
              </span>
            </Stretch>
          )}
        </Vertical>
        {!isCollapsed && (
          <Horizontal
            sizing="stretch"
            spacing={0}
            verticalAlign="center"
            className={style({
              overflow: "hidden",
            })}
          >
            <span
              className={style({
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
              })}
              data-testid="sites-list-item-name"
            >
              {text}
            </span>
          </Horizontal>
        )}
        {!isCollapsed && alertCount && <Badge>{alertCount}</Badge>}
      </Horizontal>
    );
  },
);

const collapsedTextContainer = style({
  fontSize: px(10),
  textAlign: "center",
  overflow: "hidden",
  textOverflow: "ellipsis",
});

const iconContainer = style({
  position: "relative",
});

const alertDot = style({
  position: "absolute",
  width: px(8),
  height: px(8),
  background: Styles.Colours.red,
  borderRadius: percent(50),
  border: `3px solid ${Styles.Colours.blue}`,
  top: px(-5),
  right: px(-5),
});
